import React from 'react';
import DarkLogo from '../../assets/LightLogo.svg';
import LightLogo from '../../assets/DarkLogo.svg';
import { NavLink, useHistory, useLocation, useRouteMatch } from 'react-router-dom';

const LoginWrapForm = ({ children }) => {
  const { url } = useRouteMatch();
  const { pathname } = useLocation();
  const history = useHistory();

  return (
    <>
      <strong className="login-page__logo">
        <img className="login-page__logo-img" src={JSON.parse(localStorage.getItem('nightMode')) ? LightLogo : DarkLogo } alt="anvileight" />
      </strong>
      <div className="login-page__wrap">
        <div className="login-page__form" data-testid="log-in-form">{children}</div>
        {pathname.includes('/login/') && !pathname.includes('reset') ? (
          <NavLink to={`${url}reset/`} className="login-page__link" id="login-page__forgot-password">
            Forgot password?
          </NavLink>
        ) : (
          <span
            className="login-page__link"
            style={{ cursor: 'pointer' }}
            onClick={() => (pathname.includes('error') ? history.goBack() : history.replace('/login/employee/'))}
          >
            Login
          </span>
        )}
      </div>
    </>
  );
};

export default LoginWrapForm;
